function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "EA2113B2-3DDA-4FE8-B1C8-DD24F3B8D5A5");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Dashboard---empty-chart",
  transform: "translate(-1062.000000, -129.000000)",
  fill: "#67C462",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "profile-dropdown",
  transform: "translate(1046.000000, 62.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(16.000000, 65.000000)"
}, React.createElement("g", {
  id: "logout-icon",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("path", {
  d: "M6,10.5 C6.41421356,10.5 6.75,10.8357864 6.75,11.25 C6.75,11.6642136 6.41421356,12 6,12 C2.69175,12 0,9.30825 0,6 C0,2.69175 2.69175,0 6,0 C6.41421356,0 6.75,0.335786438 6.75,0.75 C6.75,1.16421356 6.41421356,1.5 6,1.5 C3.51825,1.5 1.5,3.51825 1.5,6 C1.5,8.48175 3.51825,10.5 6,10.5 Z M11.78025,5.46975 C11.9210373,5.61029808 12.0001509,5.8010658 12.0001509,6 C12.0001509,6.1989342 11.9210373,6.38970192 11.78025,6.53025 L9.53025,8.78025 C9.38989865,8.92140693 9.19905723,9.00077614 9,9.00077614 C8.80094277,9.00077614 8.61010135,8.92140693 8.46975,8.78025 C8.32896273,8.63970192 8.24984913,8.4489342 8.24984913,8.25 C8.24984913,8.0510658 8.32896273,7.86029808 8.46975,7.71975 L9.4395,6.75 L6,6.75 C5.58578644,6.75 5.25,6.41421356 5.25,6 C5.25,5.58578644 5.58578644,5.25 6,5.25 L9.4395,5.25 L8.46975,4.28025 C8.17690101,3.98740101 8.17690101,3.51259899 8.46975,3.21975 C8.76259899,2.92690101 9.23740101,2.92690101 9.53025,3.21975 L11.78025,5.46975 Z",
  id: "Shape"
}))))));

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout-icon.8567d4f6.svg";
export { ForwardRef as ReactComponent };